/** Linear order for prev/next arrows and edge-scroll navigation (wraps at ends). */
export const PAGE_FLOW = [
  '/',
  '/our-store',
  '/products',
  '/about',
  '/contact',
];

const LABELS = {
  '/': 'Home',
  '/our-store': 'Our Store',
  '/products': 'Products',
  '/about': 'About Us',
  '/contact': 'Contact',
};

export function getFlowIndex(pathname) {
  const i = PAGE_FLOW.indexOf(pathname);
  return i === -1 ? 0 : i;
}

export function getPrevPath(pathname) {
  const i = PAGE_FLOW.indexOf(pathname);
  if (i === -1) return PAGE_FLOW[PAGE_FLOW.length - 1];
  return PAGE_FLOW[(i - 1 + PAGE_FLOW.length) % PAGE_FLOW.length];
}

export function getNextPath(pathname) {
  const i = PAGE_FLOW.indexOf(pathname);
  if (i === -1) return PAGE_FLOW[1] || '/our-store';
  return PAGE_FLOW[(i + 1) % PAGE_FLOW.length];
}

export function getPageLabel(path) {
  return LABELS[path] || 'Page';
}
